//For use on all static text unless otherwise specified
export const PRIMARY_TEXT = "#222232"

//Secondary Text Color, also Inactive Text color when text is on a background color.
export const SECONDARY_TEXT = "#B3B3BF"

//Inactive Text Color our lighter grey, avoid using on top of a background color.
export const TERTIARY_TEXT = "#D6D6E0"

//Active Text, also link/highlighted color, this is the neon blue.
export const ACTIVE_TEXT = "#5759FF"

//Selected Text, this is our darker purple, and the only purple to be used on top of a Background Color.
export const SELECTED_TEXT = "#9192C5"

//Our lightest grey, avoid using on text. Primarily used for drop shadows.
export const SMALLCHAT_SHADOW = "#EBECEF"

// Our background color generally denotes pages behind a login/user focused pages.
export const SMALLCHAT_BKG = "#F7F7F9"

//Our primary purple. Primarily used in icons and illustrations. Generally stick to darker purple for text.
export const SMALLCHAT_PURPLE = "#B6BFF3"

//Accents to be used sparingly, generally try not to use or check with Aeryk.
export const SMALLCHAT_GREEN = "#8CFFC5"
export const SMALLCHAT_PINK = "#FFE3FF"

//Used in Warnings + Bans.
export const SMALLCHAT_RED = "#FC8C9C"



// WEBPACK FOOTER //
// ./src/components/consts/colors.js